module.exports = __webpack_public_path__ + "static/media/vision.b1192a09.jpg";